import mutations from './restrictionSelect.actions'
import actions from './restrictionSelect.actions'
import getters from './restrictionSelect.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
